import { ALL_PLATFORMS, PlatformKey } from './platforms'

// #region  Global Warmer
export function warmOtherPlatformsOncePerSession(current: PlatformKey) {
  const KEY = 'pp_sso_warmup_ran_v1'
  if (sessionStorage.getItem(KEY) === '1') return

  Object.entries(ALL_PLATFORMS)
    .filter(([key]) => key !== current)
    .forEach(([, url]) => {
      const iframe = document.createElement('iframe')
      iframe.src = url
      iframe.style.display = 'none'
      iframe.setAttribute('aria-hidden', 'true')
      document.body.appendChild(iframe)
    })

  // Mark as done only after 5 seconds to ensure iframes stay mounted
  setTimeout(() => {
    sessionStorage.setItem(KEY, '1')
  }, 5000)
}

//#region LearnWorlds

// export const warmFromLearnWorlds = () => {
//   if (process.env.EXPO_PUBLIC_STAGE !== 'prod') return
//   warmOtherPlatformsOncePerSession('learn')
// }

// //#region Webflow

// export const warmFromWebflow = () => {
//   if (process.env.EXPO_PUBLIC_STAGE !== 'prod') return
//   warmOtherPlatformsOncePerSession('web')
// }
